import React from 'react'

export const Map = () => {
  return (
    <div className='bg-th-red pt-10 border-none'>
        <iframe title="thefarmhouse_map" className='bg-th-red w-full lg:w-9/12 mx-auto h-[300px] lg:h-[440px] grayscale' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10415.07117626985!2d-123.0971036!3d49.261847!3m2!1i1024!2i768!4f3!3m3!1m2!1s0x54867115048685c5%3A0x981ac2589b8eb47d!2sThe%20Farmhouse!5e0!3m2!1sen!2sca!4v1690842874991!5m2!1sen!2sca" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" zoom='19' ></iframe>
        </div>
  )
}
